import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import type { PersonalDataPage } from '../types/content'
import { formatRuDate } from '../utils/formatDate'

interface PersonalDataProps {
  data: PersonalDataPage
}


export default function PersonalData({ data }: PersonalDataProps) {
  return (
    <div className="min-h-screen bg-dark">
      <div className="container mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-primary transition-colors mb-8"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            {data.backButton}
          </Link>

          <div className="card p-8 md:p-12">
            <h1 className="text-2xl md:text-3xl font-bold text-gradient mb-4">
              {data.title}
            </h1>

            <p className="text-sm text-gray-500 mb-8">
              Последнее обновление: {formatRuDate(data.lastUpdated)}
            </p>

            <div className="prose prose-invert max-w-none">
              <p className="text-gray-300 leading-relaxed mb-8">
                {data.intro}
              </p>

              <ol className="space-y-6">
                {data.sections.map((section, index) => (
                  <motion.li
                    key={section.number}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: 0.1 + index * 0.05 }}
                    className="flex gap-4"
                  >
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm font-semibold">
                      {section.number}
                    </span>
                    <p className="text-gray-400 leading-relaxed pt-1">
                      {section.text}
                    </p>
                  </motion.li>
                ))}
              </ol>
            </div>

            <div className="mt-12 pt-8 border-t border-border">
              <p className="text-sm text-gray-500">
                {data.company.name}<br />
                ОГРН: {data.company.ogrn}<br />
                {data.company.address}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
